export const environment = {
    production: true,
    msalConfig: {
        clientID: '##{msalConfig.clientID}##',
        authority: '##{msalConfig.authority}##',
        cacheLocation: 'localStorage',
        redirectUri: '##{msalConfig.redirectUri}##',
        postLogoutRedirectUri: '##{msalConfig.postLogoutRedirectUri}##',
        protectedResourceMap: '##{msalConfig.protectedResourceMap}##',
        consentScopes: ['##{msalConfig.consentScopes}##'],
        resourceScope: '##{msalConfig.resourceScope}##',
    },
    parts_service_url: '##{parts_service_url}##',
    ADMIN_API_URL: '##{ADMIN_BASE_API_URL}##',
    currentenvironment: '##{currentenvironment}##'
};